import { FormControl, FormGroup, Validators } from '@angular/forms';

export class InvoiceForm extends FormGroup<{
  id: FormControl<number | undefined>;
  payUuid: FormControl<string | undefined>;
  totalAmt: FormControl<number | undefined>;
  paidDate: FormControl<Date | undefined>;
  status: FormControl<string | undefined>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      payUuid: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      totalAmt: new FormControl<number | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      paidDate: new FormControl<Date | undefined>(undefined, {
        nonNullable: true
      }),
      status: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      })
    });
  }
}

/*
Transactions?: Transaction[];
CompanyVendorPayments?: CompanyVendorPayment[];
*/
